import OneNewsView from './OneNewsView'

export default OneNewsView
